import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { LANGUAGE_INIT_SUCCESS, LANGUAGE_UPDATE } from './types';

const localeId = createReducer('', {
  [LANGUAGE_INIT_SUCCESS]: (_, { payload }) => payload.localeId,
  [LANGUAGE_UPDATE]: (_, { payload }) => payload.localeId,
});

export default combineReducers({
  localeId,
});
